module.exports = __webpack_public_path__ + "537d4f54696add3fb4654f64ae71b3ec.svg";